import { render, staticRenderFns } from "./NewScreenButton.vue?vue&type=template&id=4446b27f&scoped=true"
import script from "./NewScreenButton.vue?vue&type=script&lang=js"
export * from "./NewScreenButton.vue?vue&type=script&lang=js"
import style0 from "./NewScreenButton.vue?vue&type=style&index=0&id=4446b27f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4446b27f",
  null
  
)

export default component.exports